import { ChatEventType } from 'constants/chat-event-type';

export function getChatEventType(inputType: string): ChatEventType {
  if (
    inputType === (ChatEventType.Event as string) ||
    inputType === (ChatEventType.SystemMessage as string) ||
    inputType === (ChatEventType.System as string)
  ) {
    return ChatEventType.Event;
  }

  return inputType as ChatEventType;
}
